// extracted by mini-css-extract-plugin
export default {"items":"cyUw5Hs_Fptbg_JzyAUE"};